import {Component, ElementRef, ViewChild, OnInit} from "@angular/core";
import {StepService} from "../../services/step.service";
import {Router} from "@angular/router";
import {StancheckRequestService} from "../services/request.service";
import {ElementService} from "../../services/element.service";
import {AppTranslatePipe} from "../../pipe/AppTranslatePipe";
import {HaushaltForm} from "./haushalt.form";
import {StepComponent} from "../../step/step.component";
import {FormModel} from "../../form/form.model.abstract";
import {StancheckAnfrage} from "../anfrage/stancheck.anfrage";
import {PortalService} from "../../services/portal.service";

@Component({
    selector: 'app-step-haushalt-geraet',
    templateUrl: './haushalt.step.geraet.component.html',
    standalone: false
})
export class HaushaltStepGeraetComponent extends StepComponent implements OnInit {
  constructor(
    protected stepService: StepService,
    protected router: Router,
    protected elementService: ElementService,
    protected portalService: PortalService,
    protected requestService: StancheckRequestService,
    protected translate: AppTranslatePipe,
  ) {
    super(stepService, router, elementService);
  }

  protected MAX_DEVICES = 5;

  protected devices: any = [];

  protected loadingData: boolean = false;

  protected deviceErrors: { [key: number]: { error: string, fields: string[] } } = [];

  private hideHelpForSteps = [
    'waschen-und-spuelen/1',
    'waschen-und-spuelen/2',
    'waschen-und-spuelen/3',
    'waschen-und-spuelen/5',
    'kuehlen-und-gefrieren/1',
    'kuehlen-und-gefrieren/2',
    'kochen-und-backen/1',
    'kochen-und-backen/3',
    'kochen-und-backen/4',
    'kochen-und-backen/5',
    'kochen-und-backen/7',
    'kochen-und-backen/9',
    'kochen-und-backen/10',
    'unterhaltungselektronik/1',
    'unterhaltungselektronik/2',
    'unterhaltungselektronik/4',
    'unterhaltungselektronik/5',
    'unterhaltungselektronik/6',
    'unterhaltungselektronik/8',
  ];

  /**
   * The wrapper for the stepform
   */
  @ViewChild('formWrapper') formWrapper: ElementRef;

  /**
   * Holds the URL to the entrystep
   */
  entryUrl: string;

  /**
   * anfrage object
   */
  anfrage: StancheckAnfrage;

  /**
   * @inheritDoc
   */
  formConfig: HaushaltForm;

  protected addDevice(): void {
    // validate current form
    if (!this.form.valid) {
      return;
    }

    this.addDeviceFormFields();

    // scroll to the next invoice
    setTimeout(() => this.elementService.scrollToElement(this.deviceElement(this.devices.length)), 200);
  }

  private addDeviceFormFields(): void {
    const fields: FormModel[] = [];

    this.formConfig.getFieldsFromGroup(this.steps.currentStep.name).forEach((field) => {
      // ignore inactive fields
      if (field.isActive() === false) {
        return;
      }

      // clone the field and change the id
      const newField = field.clone();
      newField.setIdPostfix(this.devices.length);
      newField.setValidators(field.getValidators());
      newField.setClasses(field.getClasses());

      // set some special attributes
      newField.setTeaser(field.hasTeaser);

      // add the field to the current form for validation
      this.formConfig.addFieldToForm(this.form, newField);
      fields.push(newField);
    });

    // preset values if there are some
    this.formConfig.setData(this.anfrage.userInput);

    // add fields to local array to show the form
    this.devices.push(fields);

    // update the height
    setTimeout(() => this.stepService.heightChanged.emit(), 0);
  }

  protected removeDevice(index: number): void {
    // remove fields from form and locally saved data
    this.devices[index].forEach(field => {
      // delete localdata
      field.getIds().forEach(
        id => {
          this.form.removeControl(id);
          delete this.anfrage.userInput[id];
        }
      );
    });

    // update the anfragedata to local storage and on the server
    this.requestService.setAnfrage(this.anfrage);
    this.requestService.saveDataToServer();

    // remove from local array
    this.devices.splice(index, 1);

    // update the height
    setTimeout(() => {
      // scroll to top
      this.elementService.scrollToElement(this.deviceElement(index - 1));

      // inform the stepservice that the height changes
      this.stepService.heightChanged.emit();
    }, 0);
  }

  private deviceElement(index: number): HTMLElement {
    return document.querySelector('.device-' + index);
  }

  protected isAffectedFieldForError(index: number, field: FormModel): boolean {
    // check if at least on of the field ids is in the list of affected fields
    if (this.deviceErrors[index]) {
      // remove all numbers from the fieldnames
      const fieldIds = field.getIds().map(id => id.replace(/\d/, ''));
      // remove some extra string from the affected fields
      const fieldNames = this.deviceErrors[index].fields;

      // check if one of the ids is in the affected field list
      return fieldIds.filter(id => fieldNames.indexOf(id) > -1).length > 0;
    }
    return false;
  }

  protected deviceDescription(index: number): string {
    return this.translate.transform('stancheck.geraet.headline.' + this.stepname(), {count: index + 1});
  }

  /**
   * Prevent auto submit so more devices can be added
   */
  setAutoSubmitAndInlineHelp() {}

  private initDevices(): void {
    const fields = this.formConfig.getFieldsFromGroup(this.steps.currentStep.name);
    this.devices.push(fields);
    const firstField = fields[0].id;
    for (let index = 1; index < this.MAX_DEVICES - 1; index++) {
      if (!this.anfrage.userInput.hasOwnProperty(firstField + index)) {
        break;
      }
      this.addDeviceFormFields();
    }
  }

  ngOnInit() {
    this.formConfig = new HaushaltForm();
    this.anfrage = this.requestService.getAnfrage();
    this.textkeyPrefix = 'stancheck';
    super.ngOnInit();
    this.formConfig.anfrage = this.anfrage;
    // this.subscriptions.push(this.form.valueChanges.subscribe(() => {}));
    this.formConfig.setData(this.anfrage.userInput);
    if (this.steps.currentStep && this.hideHelpForSteps.includes(this.steps.currentStep.name)) {
      this.hideHelp();
    }
    this.initDevices();
    this.entryUrl = this.portalService.currentPortalId + '/stancheck';
    this.onStepUpdate();
  }

  /**
   * @inheritDoc
   */
  async onSubmit() {
    // this.resetErrors();

    if (!this.form.valid) {
      return;
    }

    // save the input up to here
    this.saveData(this.formConfig.getData());

    this.loadingData = false;
    this.requestService.setAnfrage(this.anfrage);
    this.moveToNextStep();
  }

  /**
   * @inheritDoc
   * @param data
   */
  saveData(data: { [key: string]: any }) {
    // merge the data with the existing data
    this.anfrage.userInput = {...this.anfrage.userInput, ...data};
    this.requestService.setAnfrage(this.anfrage);

    // save the data also to the server
    this.requestService.saveDataToServer();
  }

  private stepname(): string {
    return this.steps.currentStep.name.replace('/', '.');
  }

  // onStepUpdate() {
  //   super.onStepUpdate();
  //
  //   const stepname = this.stepname();
  //   // override the headline and helptext to get one for every step
  //   this.headlineTextkey = 'stancheck.stepname.' + stepname;
  //   this.helpTextkey = 'stancheck.help.' + stepname;
  // }
}
